<template lang="pug">
    section.homeRegions 
      .homeRegions-heroImage: img.homeRegions-heroImage(alt, src='@/assets/images/regions/hero.jpg')
      .homeRegions-titlebox
        h2.homeRegions-title Neighborhoods <br/> of Turks and Caicos
        .homeRegions-textWrap
          p.homeRegions-text We have offers in all regions <br/> of Turks and Caicos
          button.homeRegions-button(@click='$router.push({ name: "ListingsPage"})') ALL LISTINGS
      .homeRegions-contentbox
        .homeRegions-contentItem(v-for='region in displayedRegions', :key='region.id')
          .homeRegions-contentItem-image
            img(:src='region.image', :alt='region.title')
          .homeRegions-contentItem-title 
            span {{ region.title }}
            SvgComponent(name='arrow')
          .homeRegions-contentItem-desc {{ region.desc }}
        button.showMore(@click='$router.push({ name: "ListingsPage"})') ALL LISTINGS  
      
</template>

<script>
  export default {
    components: {
      SvgComponent: () => import('@/components/SvgComponent'),
    },
    data() {
    return {
      isMobile: false,
      regions: [
        {
          id: 'providenciales',
          image: require('@/assets/images/regions/providenciales.jpg'),
          title: 'Providenciales',
          desc: "The epicenter of luxury living, with Grace Bay's iconic beaches, world-class villas, and refined island lifestyle",
        },
        {
          id: 'grand-turk',
          image: require('@/assets/images/regions/grand-turk.jpg'),
          title: 'Grand Turk',
          desc: 'Historic charm and colonial elegance, offering intimate settings and exclusive seaside retreats'
        },
        {
          id: 'north-caicos',
          image: require('@/assets/images/regions/north-caicos.jpg'),
          title: 'North Caicos',
          desc: 'Lush landscapes and secluded shores — ideal for private villas and serene island living'
        },
        {
          id: 'middle-caicos',
          image: require('@/assets/images/regions/middle-caicos.jpg'),
          title: 'Middle Caicos',
          desc: 'Dramatic cliffs and hidden coves create a breathtaking backdrop for rare and exclusive estates'
        },
        {
          id: 'south-caicos',
          image: require('@/assets/images/regions/south-caicos.jpg'),
          title: 'South Caicos',
          desc: 'Authentic and tranquil, where heritage meets privacy in pristine oceanfront residences'
        }
      ]
    }
  },
    computed: {
    displayedRegions() {
      return this.isMobile ? this.regions.slice(0, 3) : this.regions;
    }
  },
   mounted() {
    this.checkMobile();
    window.addEventListener('resize', this.checkMobile);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkMobile);
  },
  methods: {
    checkMobile() {
      this.isMobile = window.innerWidth < 768;
    }
  }
  };
</script>

<style lang="scss">
  .homeRegions {
  background: #FFFAF3;
  color: #1F1E1E;
  margin-bottom: 120px;

  @include tablet {
    margin-bottom: 60px;
  }

  @include phone {
    margin-bottom: 0;
  }

  &-heroImage {
    margin-bottom: 125px;
    width: 100%;

    @include tablet {
      margin-bottom: 60px;
    }

    @include phone {
      margin-bottom: 32px;
      height: 390px;

      img {
        object-fit: cover;
      }
    }
  }

  &-titlebox {
    padding: 0 100px;
    display: flex;
    gap: 30px;
    margin-bottom: 63px;

    @include tablet {
      padding: 0 0 40px 0;
      gap: 20px;
      margin-bottom: 0px;
    }

    @include phone {
      padding: 0;
      flex-direction: column;
      margin: 0 16px 24px;
      gap: 0;
    }

    h2 {
      font-family: 'Abhaya Libre';
      font-weight: 800;
      width: 638px;
      text-align: right;
      font-size: 72px;


      @include tablet {
        font-size: 50px;
        line-height: 50px;
        margin-left: 50px;
        width: auto;
      }

      @include phone {
        width: 100%;
        font-size: 42px;
        text-align: left;
        margin-left: 0;
      }
    }

    .homeRegions-textWrap {
      display: flex;
      flex-direction: column;
      gap: 20px;

      @include tablet {
        gap: 12px;
      }


      .homeRegions-text {
        font-size: 24px;
        font-weight: 700;
        width: 340px;
        margin-top: 16px;

        @include tablet {
          font-size: 18px;
          margin-top: 8px;
          width: auto;
        }

        @include phone {
          display: none;
        }
      }

      .homeRegions-button {
        padding: 15px 30px;
        text-transform: uppercase;
        border: 1px solid #d41e34;
        width: max-content;
        font-size: 17px;
        font-weight: 700;
        color: #d41e34;
        cursor: pointer;

        &:hover {
          background: #d41e34;
          color: white;
          transition: ease-in-out 0.2s;
        }

        @include tablet {
          padding: 12px 24px;
        }

        @include phone {
          display: none;
        }
      }
    }
  }

  &-contentbox {
    margin: 0 100px;
    padding-bottom: 60px;
    display: flex;
    gap: 30px;
    overflow-x: scroll;

    @include tablet {
      margin: 0 50px;
      padding-bottom: 40px;
      gap: 20px;
    }

    @include phone {
      flex-direction: column;
      margin: 0 16px;
    }

    .homeRegions-contentItem {
      width: 290px;
      height: 600px;
      transition: width 0.3s ease-out 0.2s;
      position: relative;
      flex-shrink: 0;
      padding: 40px;
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      color: white;

      &:before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: linear-gradient(180deg, rgba(0, 0, 0, 0) 70.02%, rgba(0, 0, 0, 0.405) 84.28%, rgba(0, 0, 0, 0.45) 100%);
        z-index: 1;
      }

      @include tablet {
        width: 152px;
      }

      @include phone {
        width: 100% !important;
        padding: 0;
        height: 100%;
        color: #1F1E1E;

        &:before {
          display: none;
        }
      }

      &-image {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 0;

        @include phone {
          width: 100%;
          position: relative;
          height: 368px;
        }

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.3s ease-out;
        }
      }

      &-title {
        z-index: 2;
        position: relative;
        font-size: 24px;
        font-weight: 700;
        margin-bottom: 8px;
        display: flex;
        align-items: center;
        gap: 16px;

        svg {
          display: none;
          transform: rotate(180deg);
        }

        @include phone {
          margin-top: 16px;

          svg {
            display: block;
          }
        }
      }

      &-desc {
        height: 0;
        z-index: 2;
        position: relative;
        overflow: hidden;
        transition: height 0.3s ease-out 0.2s;

        @include phone {
          height: max-content;
          overflow: visible;
          font-size: 16px;
        }
      }

      &:first-child {
        width: 600px;

        .homeRegions-contentItem-desc {
          height: 44px;
        }

        @include tablet {
          width: 324px;
          .homeRegions-contentItem-desc {
            height: 72px;
          }
        }

        @include phone {
          width: 100%;

          .homeRegions-contentItem-desc {
            height: max-content;
          }
        }

        
      }

      &:hover {
        width: 600px;
        transition: width 0.3s ease-out 0s;

        .homeRegions-contentItem-desc {
          transition: height 0.3s ease-in 0s;
          height: 44px;
        }

        @include tablet {
          width: 324px;
          .homeRegions-contentItem-desc {
          transition: height 0.3s ease-in 0s;
          height: 72px;
        }
        }

        @include phone {
          width: 100%;

          .homeRegions-contentItem-desc {
            height: max-content;
          }
        }
      }
    }

    .showMore {
      width: 100%;
      padding: 16px;
      background: #1F1E1E;
      color: #FFFAF3;
      border: none;
      font-size: 16px;
      font-weight: 700;
      cursor: pointer;
      text-transform: uppercase;
      text-align: center;
      display: none;

      @include phone {
        display: block;
      }
    }

    &:has(.homeRegions-contentItem:hover) .homeRegions-contentItem:not(:hover) {
      width: 290px;

      .homeRegions-contentItem-desc {
        height: 0;

        @include tablet {
          width: 152px;
        }

        @include phone {
          height: max-content;
        }
      }
    }

    &::-webkit-scrollbar {
      -webkit-appearance: none;
      width: 4px;
      height: 4px;
    }

    &::-webkit-scrollbar-thumb {
      background: #888;
      border-radius: 4px;
      transition: background 0.2s ease-out;

      &:hover {
        background: $red;
        transition: background 0.2s ease-in;
      }
    }

    &::-webkit-scrollbar-track {
      background: #EDEDED;
      border-radius: 4px;

      @include phone {
        display: none;
      }
    }
  }
}
</style>